import Home from '@/views/Home.vue'
import Stepper from '@/views/Stepper.vue'
import Typography from '@/views/Typography.vue'
import Store from '@/views/Store.vue'
import Success from '@/views/Success.vue'
import Admin from '@/views/admin/Admin.vue'
import Apartment from '@/views/admin/Apartment.vue'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/stepper',
        name: 'Stepper',
        component: Stepper
    },
    {
        path: '/success',
        name: 'Success',
        component: Success
    },
    {
        path: '/Admin',
        name: 'Admin',
        component: Admin,
        children: [
            {
                path: '/apartment/:id',
                name: 'Apartment',
                component: Apartment
            },
        ]
    },
    // {
    //     path: '/typography',
    //     name: 'Typography',
    //     component: Typography
    // },
    // {
    //     path: '/store',
    //     name: 'Store',
    //     component: Store
    // },
]

export default routes
